/** An empty value passes - pair it with `required` where the field is mandatory */
export const validateWhitespace = (value: string | number) => {
  const text = String(value);

  return !text || !!text.trim() || "Can't contain only whitespace";
};
